<script>
    export let text = "Načítání";
    export let style = "margin: 0 auto 0 auto; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;";
    export let height = "100%";
</script>

<div
    class="blok-nacitani"
    style={`${style} height:${height};`}
    height={height}
    >
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width="24" height="24" 
        stroke="#000" 
        viewBox="0 0 24 24" 
        style="width: 100%;"
        >
        <style>.spinner_V8m1{transform-origin:center;animation:spinner_zKoa 2s linear infinite}.spinner_V8m1 circle{stroke-linecap:round;animation:spinner_YpZS 1.5s ease-in-out infinite}@keyframes spinner_zKoa{100%{transform:rotate(360deg)}}@keyframes spinner_YpZS{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59}}</style><g class="spinner_V8m1"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/></g>
    </svg>
    <span style="display: block; width: 100%; text-align: center;">{text}</span>
</div>